import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const PostReverseProposalRequestSchema = z
  .object({
    goodsNo: z.number().min(1),
    startAt: z.string().regex(/\d{8}/),
    message: z.string(),
  })
  .describe('PostReverseProposalRequestSchema');

export type PostReverseProposalRequest = z.infer<typeof PostReverseProposalRequestSchema>;

const PostReverseProposalResponseDataSchema = z
  .object({
    id: z.number(),
  })
  .describe('PostReverseProposalResponseDataSchema');

const PostReverseProposalResponseSchema = createApiResponseSchema(
  PostReverseProposalResponseDataSchema,
);

export type PostReverseProposalResponse = z.infer<typeof PostReverseProposalResponseSchema>;

export const postReverseProposal = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PostReverseProposalRequestSchema),
    async (params: PostReverseProposalRequest): Promise<PostReverseProposalResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.post<PostReverseProposalResponse>(
          urlJoin(campaignsApiPath.postReverseProposal),
          params,
        );
        return response;
      }),
    validateApiResponse(PostReverseProposalResponseSchema),
  ),
);
